import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { AccountService } from './_services/account.service';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private idleTime = 0;
  private readonly idleLimit = 20 * 60; // 20 minutes
  private readonly idleWarningLimit = 18 * 60; // 18 minutes (2 min before logout)

  private idleInterval: any = null;
  private warningShown = false;
  private readonly timeoutWarningSubject = new Subject<number>();
  public timeoutWarning$: Observable<number> = this.timeoutWarningSubject.asObservable();

  constructor(private readonly accountService: AccountService) {}

  resetIdleTimer(): void {
    this.idleTime = 0;
    this.warningShown = false;
  }

  startIdleTimer(): void {
    const isLoggedIn = !!sessionStorage.getItem('user');
    if (!isLoggedIn) {
      console.log('User is not logged in, skipping idle timer.');
      return;
    }

    if (this.idleInterval) return; // Prevent multiple timers

    this.resetIdleTimer();

    this.idleInterval = setInterval(() => {
      this.idleTime++;

      if (this.idleTime >= this.idleWarningLimit && !this.warningShown) {
        const timeLeft = this.idleLimit - this.idleTime;
        this.warningShown = true;
        this.timeoutWarningSubject.next(timeLeft);
      }

      if (this.idleTime >= this.idleLimit) {
        this.logout();
      }
    }, 1000);
  }

  stopIdleTimer(): void {
    clearInterval(this.idleInterval);
    this.idleInterval = null;
  }

  logout(): void {
    this.stopIdleTimer();
    this.accountService.logout();
  }
}
